<div [formGroup]="formGroup" class="input-group">
	<input #input
		class="form-control form-control-border"
		[ngClass]="{'disabled': formGroup.controls['birthDate'] && formGroup.controls['birthDate'].disabled}"
		placeholder="yyyy-mm-dd"
		name="formControlName" id="formControlName"
    (blur)="focusOut()"
		ngbDatepicker #d1="ngbDatepicker"
		[formControlName]="formControlName"
		[minDate]="getMinDate()"
		[maxDate]="getMaxDate()"
		(click)="d1.toggle()">
	<span *ngIf="clearInput && input.value" class="input-group-btn clear-group-btn">
		<button class="btn" type="button" (click)="clearDateInput()">
			<i class="fa fa-times fa-lg" aria-hidden="true"></i>
		</button>
	</span>
	<span *ngIf="calendarIcon" class="input-group-btn">
		<button class="btn" type="button" (click)="d1.toggle()">
			<i class="fa fa-calendar fa-lg" aria-hidden="true"></i>
		</button>
	</span>
</div>
